import React from 'react'
import './index.scss'
import { renderIf } from '../../../lib/util'

export default class Button extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showRipple: false
    }
  }

  render() {
    let { props } = this
    return (
      <React.Fragment>
        {
          renderIf(props.type !== 'submit',
            <button
              style={props.style}
              title={props.title}
              type={props.type}
              id={props.id}
              name={props.name}
              disabled={props.disabled}
              className={'btn ' + props.className + (props.gray ? ' gray' : '')}
              onClick={e => {
                if (e) e.preventDefault()
                if (props.ripple) {
                  this.setState({ showRipple: true })
                  setTimeout(() => this.setState({ showRipple: false }), 750)
                }
                if (props.onClick) props.onClick(e)
              }}
            >
              {props.children}

              {renderIf(this.state.showRipple, <div className="ripple-effect" />)}
            </button>,
            <button
              style={props.style}
              title={props.title}
              type={props.type}
              id={props.id}
              disabled={props.disabled}
              className={'btn ' + props.className + (props.gray ? ' gray' : '')}
              onMouseUp={e => {
                if (e) e.preventDefault()
                if (props.ripple) {
                  this.setState({ showRipple: true })
                  setTimeout(() => this.setState({ showRipple: false }), 750)
                }
                if (props.onClick) props.onClick(e)
              }}
            >
              {props.children}

              {renderIf(this.state.showRipple, <div className="ripple-effect" />)}
            </button>
          )
        }
      </React.Fragment>
    )
  }
}
